import script from "./RenderIconChart.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderIconChart.vue?vue&type=script&setup=true&lang=js"

import "./RenderIconChart.vue?vue&type=style&index=0&id=d79ab686&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d79ab686"]])

export default __exports__